import React, { useState, useEffect } from "react";
import Axios from "axios";
import { connect } from "react-redux";

import DirectoryExplorerSelector from "MetaComponent/selectors/DirectoryExplorer";
import DirectoryExplorerApi from "MetaComponent/api/DirectoryExplorer";
import DesignTargetApi from "MetaComponent/api/DesignTarget";

import GenericJobOverview from "./GenericJobOverview";
import GenericApi from "Api";

export function PSRTUploadJobOverview({ filters }) {
  const [error, setError] = useState(false);
  const [data, setData] = useState(null);

  /**
   * it makes a request to get all the psrt upload jobs
   */
  const fetchJobs = async () =>
    Axios.get(`${GenericApi.getBaseUrl()}/uploadpsrtjobs_all/`)
      .then(response => {
        setData(handleFetchJobsComplete(response.data));
      })
      .catch(() => {
        handleFetchJobsError();
        setData([]);
      });

  /**
   * it sets the state that is used for the table data
   */
  const handleFetchJobsComplete = data => {
    if (data && data.length > 0) {
      const tableData = data.map(job => {
        return {
          itemId: job.id,
          name: job.meta_component_name,
          metaComponent: job.meta_component,
          mcGroup: job.mc_group,
          status: job.status,
          errors: job.errors
        };
      });
      return tableData;
    } else {
      return [];
    }
  };

  useEffect(() => {
    fetchJobs();
  }, []);

  const handleFetchJobsError = () => {
    setError(true);
  };

  /**
   * @param {Number} jobId - the psrt upload job id
   * @returns {Promise} - the promise that stops the job at the endpoint
   */
  const stopUploadPsrtJob = async jobId => {
    const job = data.find(job => job.itemId === jobId);
    return DesignTargetApi.stopUploadPsrtJob(job.metaComponent).then(() =>
      Promise.resolve(true)
    );
  };

  /**
   * @param {Number} jobId - the psrt upload job id
   * @returns {Object} errors and warnings extracted from the job
   */
  const getUploadPsrtJobErrors = async jobId => {
    const job = data.find(job => job.itemId === jobId);
    const { errors } = job;
    return { errors };
  };

  /**
   * @callback
   * @param {Object} newData
   */
  const updateData = newData => {
    setData(newData);
  };

  return (
    <>
      <GenericJobOverview
        data={data}
        updateData={updateData}
        error={error}
        getErrorsAndWarnings={getUploadPsrtJobErrors}
        stopJob={stopUploadPsrtJob}
        filters={filters}
        grouperColumns={[
          { title: "Group", field: "mcGroup", defaultGroupOrder: 0 },
          {
            title: "Meta Component",
            field: "metaComponent",
            defaultGroupOrder: 1
          }
        ]}
      />
    </>
  );
}

const mapStateToProps = state => ({
  mcGroups: DirectoryExplorerSelector.getMCGroups(state),
  metaComponents: DirectoryExplorerSelector.getMetaComponents(state)
});

const mapDispatchToProps = dispatch => {
  return {
    fetchMCGroupsAndMetaComponentsAction: () =>
      dispatch(DirectoryExplorerApi.fetch())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PSRTUploadJobOverview);
